import { render, staticRenderFns } from "./ModalBackofficeRecorrencia.vue?vue&type=template&id=467e224d&scoped=true"
import script from "./ModalBackofficeRecorrencia.vue?vue&type=script&lang=ts"
export * from "./ModalBackofficeRecorrencia.vue?vue&type=script&lang=ts"
import style0 from "./ModalBackofficeRecorrencia.vue?vue&type=style&index=0&id=467e224d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467e224d",
  null
  
)

export default component.exports